import { defineMessages } from 'react-intl';

export default defineMessages({
  benefitAreYouClaimingFor: {
    id: 'fastCover.step17.benefitAreYouClaimingFor',
    defaultMessage: 'Which Benefit are you claiming for?',
  },

  localBurial: {
    id: 'fastCover.step17.localBurial',
    defaultMessage: 'Local Burial',
  },

  repatriation: {
    id: 'fastCover.step17.repatriation',
    defaultMessage: 'Repatriation',
  },

  assistance: {
    id: 'fastCover.step17.assistance',
    defaultMessage: 'Assistance company/Claims / Administrator Approval Number',
  },

  dateApproved: {
    id: 'fastCover.step17.dateApproved',
    defaultMessage: 'Date Approved',
  },

  causeOfDeath: {
    id: 'fastCover.step17.causeOfDeath',
    defaultMessage: 'Cause Of Death',
  },

  dateOfDeath: {
    id: 'fastCover.step17.dateOfDeath',
    defaultMessage: 'Date Of Death',
  },

  stateOfDeath: {
    id: 'fastCover.step17.stateOfDeath',
    defaultMessage: 'State Of Death',
  },

  countryOfDeath: {
    id: 'fastCover.step17.countryOfDeath',
    defaultMessage: 'Country Of Death',
  },

  wasTheMemberHospitalized: {
    id: 'fastCover.step17.wasTheMemberHospitalized',
    defaultMessage: 'Was the Member Hospitalized',
  },

  yes: {
    id: 'fastCover.step17.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.step17.no',
    defaultMessage: 'No',
  },

  from: {
    id: 'fastCover.step17.from',
    defaultMessage: 'From',
  },

  to: {
    id: 'fastCover.step17.to',
    defaultMessage: 'To',
  },

  nameOfFuneralServiceProvider: {
    id: 'fastCover.step17.nameOfFuneralServiceProvider',
    defaultMessage: 'Name of Funeral Service Provider',
  },

  costOfLocalBurial: {
    id: 'fastCover.step17.costOfLocalBurial',
    defaultMessage: 'Cost of Local Burial',
  },

  invoice: {
    id: 'fastCover.step17.invoice',
    defaultMessage: 'Invoice',
  },

  amountClaimed: {
    id: 'fastCover.step17.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },

  currency: {
    id: 'fastCover.step17.currency',
    defaultMessage: 'Currency',
  },

  familyMemberProvidingInformation: {
    id: 'fastCover.step17.familyMemberProvidingInformation',
    defaultMessage: 'Family member providing information (claimant)',
  },

  relationshipToMember: {
    id: 'fastCover.step17.relationshipToMember',
    defaultMessage: 'Relationship to Member',
  },

  address: {
    id: 'fastCover.step17.address',
    defaultMessage: 'Address',
  },

  cityOrTown: {
    id: 'fastCover.step17.cityOrTown',
    defaultMessage: 'City Or Town',
  },

  country: {
    id: 'fastCover.step17.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.step17.postalCode',
    defaultMessage: 'Postal Code',
  },

  phoneNumber: {
    id: 'fastCover.step17.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  isRequired: {
    id: 'fastCover.step17.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },

});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step17/messages.js